export function isSimulatorRenderer(obj) {
  return obj && obj.isSimulatorRenderer;
}